import { render, staticRenderFns } from "./Alliance.vue?vue&type=template&id=05e478ee&"
import script from "./Alliance.vue?vue&type=script&lang=js&"
export * from "./Alliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports